<template>
  <Day day="18.12.2025">
    <div slot="page-content">
      <h3>Unser erstes gemeinsames Konzert - Heavysaurus 🤘</h3>
      <p>
        <img src="@/assets/day17.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day18',
  components: {
    Day
  }
}
</script>
